export default "__VITE_ASSET__CPb7vq8P__"